import React from "react";
import styled from "styled-components";
import { MatchSummary } from "../components";

const PlayoffsView = ({ playoffs }) => {
  console.log(playoffs);
  return (
    <Wrapper>
      {playoffs.length === 0 ? (
        <p>Todavía no se han creado las partidas de playoffs</p>
      ) : (
        ""
      )}
      {playoffs
        .sort((a, b) =>
          a.playoffType &&
          a.playoffType.toLowerCase() > b.playoffType &&
          b.playoffType.toLowerCase()
            ? 1
            : -1
        )
        .map((match) => {
          return (
            <div key={`match-${match.matchId}`} className="match-component">
              <h4>
                {match.phase === "PLAYOFF" ? "Playoff de " : ""}
                {match.playoffType ? match.playoffType.toLowerCase() : ""}
              </h4>
              <MatchSummary {...match} />
            </div>
          );
        })}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;

  .match-component {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
`;

export default PlayoffsView;
